import Vue from 'vue';
import moment from 'moment';
import table from '../../../components/console-common/table.vue';
import { toYuan } from '../../../utils/unit-conversion';
export default Vue.extend({
    name: 'fundBalance',
    components: {
        'el-repayment-list': table,
    },
    data: function () {
        return {
            status: '',
            applyTimeStart: '',
            applyTimeEnd: '',
            dateRange: [],
            date: '',
            otherParam: {
                applyTimeStart: '',
                applyTimeEnd: '',
                status: '',
            },
            cardData: [
                {
                    tit: '可用余额',
                    money: 0,
                    btn: true,
                    use: true,
                    secTitle: '系统每月15日自动提现',
                    tips: true,
                },
                {
                    tit: '处理中金额',
                    money: 0,
                },
            ],
            exportConfig: {
                fileName: '还款明细列表',
                keyUrl: '/proxy/api/account/withdraw/export',
                statusUrl: '/proxy/api/getFileUrl',
                statusKeys: 'fileGiftKey',
            },
            requestConfig: {
                url: '/proxy/api/account/withdraw/page',
                method: 'post',
            },
            tableConfig: [
                {
                    label: '申请提现时间',
                    prop: 'time',
                    minWidth: '200px',
                    formatter: function (val) {
                        return moment(val).format('YYYY-MM-DD HH:mm:ss');
                    },
                },
                {
                    label: '流水号',
                    prop: 'orderId',
                    tooltip: true,
                    minWidth: '200px',
                },
                {
                    label: '金额(元)',
                    prop: 'amount',
                    minWidth: '180px',
                    align: 'right',
                    formatter: function (val) {
                        return toYuan(val).toFixed(2);
                    },
                },
                {
                    label: '结算账户',
                    prop: 'bankName',
                    minWidth: '200px',
                    formatter: function (val, row) {
                        return row.bankName + "(" + row.cardNo + ")";
                    },
                },
                {
                    label: '提现状态',
                    prop: 'status',
                    tooltip: true,
                    minWidth: '320px',
                    filterMultiple: false,
                    filters: [
                        {
                            text: '提现中',
                            value: 'APPLIED',
                        },
                        {
                            text: '提现成功',
                            value: 'SUCCESS',
                        },
                        {
                            text: '提现失败',
                            value: 'FAIL',
                        },
                    ],
                    formatter: function (val, row) {
                        var change = {
                            APPLIED: '提现中',
                            SUCCESS: '提现成功',
                            FAIL: '提现失败',
                            REFUND: '退单不付',
                        };
                        return row.resultDesc
                            ? change[val] + "(" + row.resultDesc + ")"
                            : change[val];
                    },
                },
            ],
            cellConfig: {
                status: [
                    {
                        status: 'FAIL',
                        style: 'color:#FF5257',
                    },
                ],
            },
        };
    },
    created: function () {
        this.getBalance();
    },
    methods: {
        updateOtherParams: function () {
            var _a = this, applyTimeStart = _a.applyTimeStart, applyTimeEnd = _a.applyTimeEnd, status = _a.status;
            this.otherParam = {
                applyTimeStart: applyTimeStart,
                applyTimeEnd: applyTimeEnd,
                status: status,
            };
        },
        getBalance: function () {
            var _this = this;
            this.$request({
                url: 'proxy/api/account/balance',
                method: 'post',
                data: {},
            }).then(function (res) {
                if (!res || res.errorCode) {
                    return;
                }
                var _a = res.data, total = _a.total, draw = _a.draw;
                var able = toYuan(draw);
                var unable = toYuan(total - draw);
                _this.cardData[0].money = able;
                _this.cardData[1].money = unable;
            });
        },
        withdraw: function () {
            this.$router.push({ name: 'fundBalanceSure' });
        },
        filterChange: function (filters) {
            for (var key in filters) {
                this[key] = filters[key].length > 0 ? filters[key][0] : '';
            }
            this.updateOtherParams();
        },
        tabDateRange: function (val) {
            this.date = '';
            var startTime = '';
            var endTime = '';
            startTime = val ? moment(val[0]).format('YYYY-MM-DD') : '';
            endTime = val ? moment(val[1]).format('YYYY-MM-DD') : '';
            this.applyTimeStart = startTime;
            this.applyTimeEnd = endTime;
            this.updateOtherParams();
        },
        tabDate: function (val) {
            this.dateRange = [];
            var startTime = '';
            var endTime = '';
            var currentDate = new Date();
            var getDateRange = function (date) {
                startTime = moment(new Date(date.getFullYear(), date.getMonth(), 1)).format('YYYY-MM-DD');
                endTime = moment(date).format('YYYY-MM-DD');
            };
            if (val === 'current') {
                var currentMonth = new Date(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1).getTime() -
                    1 * 24 * 60 * 60 * 1000);
                getDateRange(currentMonth);
            }
            if (val === 'last') {
                var lastMonth = new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getTime() -
                    1 * 24 * 60 * 60 * 1000);
                getDateRange(lastMonth);
            }
            this.applyTimeStart = startTime;
            this.applyTimeEnd = endTime;
            this.updateOtherParams();
        },
    },
});
